import {
  Accordion,
  AccordionContent,
  AccordionPanel,
  AccordionTitle,
} from "flowbite-react"
import React, { useState } from "react"
import { ReactComponent as NotOpenIcon } from "../../images/plus-icon.svg"
import { ReactComponent as OpenIcon } from "../../images/minus-icon.svg"

const CommonFaqs = ({ data }) => {
  const [panelId, setPanelId] = useState(1)
  const handlePanelToggle = value => {
    setPanelId(prev => {
      if (prev === value) {
        return 0
      }
      return value
    })
  }
  return (
    <section className=" bg-white-100 items-center flex flex-col gap-10 md:gap-24 py-12 md:py-[6.75rem]">
      <div className="w-full flex md:px-20 md:pe-10 xll:pe-20 px-6 flex-col gap-4 items-end   xl:px-20 ">
        <h4 className="flex text-gray-500 text-lg lg:text-2xl items-center tracking-tight-2% lg:tracking-tight-4% gap-2">
          {" "}
          <div className="w-[8px]  inline-block rounded-full h-[8px] bg-blue-100"></div>
          {data.section}
        </h4>
        <h3 className="text-gray-100 text-[3.7rem] md:text-7xl text-end lg:text-8xl tracking-[-3.36px] lg:tracking-tight-7%">
          {data.label}
        </h3>
      </div>
      <div className="   w-full px-6 md:w-4/5 xl:w-2/3    ">
        <p className="text-gray-800 mb-10 md:mb-8 text-2xl ">{data.faqTitle}</p>
        <Accordion
          arrowIcon={null}
          className="border-0 divide-y-0 flex flex-col gap-4 md:gap-6"
        >
          {data.faqs.map((item, index) => {
            const id = index + 1
            return (
              <AccordionPanel key={id} className="">
                <AccordionTitle
                  theme={{ heading: " w-full text-xl -tracking-[0.4px]" }}
                  className={`${panelId === id ? "!bg-white-200" : "!bg-transparent"}  focus:ring-0 px-3 md:px-6 !text-black-400 py-0 `}
                >
                  <div
                    onClick={() => handlePanelToggle(id)}
                    className="flex py-4 w-full gap-2 justify-between"
                  >
                    <span>{item.header}</span>
                    <span className="flex-shrink-0">
                      {panelId === id ? <OpenIcon /> : <NotOpenIcon />}
                    </span>
                  </div>
                </AccordionTitle>
                <AccordionContent className="px-3 md:px-6 text-base rounded-b-[14px] pb-6 !tracking-[0.32px] bg-white-200 text-gray-800 -mt-8 md:-mt-11">
                  <div>{item.description}</div>
                </AccordionContent>
              </AccordionPanel>
            )
          })}
        </Accordion>
      </div>{" "}
    </section>
  )
}

export default CommonFaqs
